import { useEffect, useRef, useState } from "react";

/** Countdown in second */
const useCountdown = (from: number, callback?: () => void) => {
  const SECOND_IN_MS = 1000;

  const timerRef = useRef<NodeJS.Timeout>(undefined);
  const [count, setCount] = useState<number>();

  const cleanup = () => {
    timerRef.current && clearInterval(timerRef.current);
  };

  useEffect(() => {
    if (count === from) {
      timerRef.current = setInterval(
        () =>
          setCount(prev => {
            const next = (prev || 0) - 1;
            next === 0 && cleanup();
            return Math.max(0, next);
          }),
        SECOND_IN_MS
      );
    }
  }, [count]);

  useEffect(() => {
    count === 0 && callback?.();
  }, [count]);

  const start = () => setCount(from);

  return {
    count,
    start,
    cleanup,
  };
};

export default useCountdown;
